var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container text-center" }, [
    _c("h1", { staticClass: "display-4" }, [_vm._v("Ich bin neu!")]),
    _vm._v(" "),
    _c("p", { staticClass: "lead" }),
    _vm._v(" "),
    _c(
      "form",
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-group has-warning" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email",
              },
            ],
            staticClass: "form-control",
            class: {
              "is-valid": _vm.isValidMail,
              "is-invalid": !_vm.isValidMail,
            },
            attrs: {
              type: "email",
              id: "email",
              placeholder: "name@example.com",
              required: "",
            },
            domProps: { value: _vm.email },
            on: {
              change: _vm.validateInitialMail,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.email = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.confirmemail,
                expression: "confirmemail",
              },
            ],
            staticClass: "form-control",
            class: {
              "is-valid": _vm.isValidCompareMail,
              "is-invalid": !_vm.isValidCompareMail,
            },
            attrs: {
              type: "email",
              id: "confirmemail",
              placeholder: "name@example.com",
              required: "",
            },
            domProps: { value: _vm.confirmemail },
            on: {
              change: _vm.compareMail,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.confirmemail = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.pw,
                expression: "pw",
              },
            ],
            staticClass: "form-control",
            class: {
              "is-valid": _vm.isValidPassword,
              "is-invalid": !_vm.isValidPassword,
            },
            attrs: {
              type: "password",
              id: "pw",
              placeholder: "Passwort",
              required: "",
            },
            domProps: { value: _vm.pw },
            on: {
              change: _vm.validatePassword,
              keyup: _vm.validatePassword,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.pw = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.confirmpw,
                expression: "confirmpw",
              },
            ],
            staticClass: "form-control",
            class: {
              "is-valid": _vm.isValidPassword,
              "is-invalid": !_vm.isValidPassword,
            },
            attrs: {
              type: "password",
              id: "confirmpw",
              placeholder: "Bestätigung Passwort",
              required: "",
            },
            domProps: { value: _vm.confirmpw },
            on: {
              change: _vm.comparePassword,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.confirmpw = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "b-form-checkbox",
          {
            staticClass: "mt-4",
            attrs: { name: "some-radios", value: "1" },
            model: {
              value: _vm.agbCheckbox,
              callback: function ($$v) {
                _vm.agbCheckbox = $$v
              },
              expression: "agbCheckbox",
            },
          },
          [
            _vm._v("Ich habe die "),
            _c("b-link", { attrs: { target: "_blank", href: "/agb" } }, [
              _vm._v("AGB's"),
            ]),
            _vm._v(" gelesen und akzeptiert"),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-lg btn-primary btn-block mt-4",
            attrs: {
              type: "button",
              disabled:
                Object.keys(_vm.hasError).length > 0 ||
                _vm.agbCheckbox === false,
            },
            on: { click: _vm.signup },
          },
          [_vm._v("Anmelden")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group text-left mb-0 mt-4" }, [
      _c("label", { staticClass: "control-label", attrs: { for: "email" } }, [
        _vm._v("E-Mailadresse"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group text-left mt-4" }, [
      _c(
        "label",
        { staticClass: "control-label", attrs: { for: "confirmemail" } },
        [_vm._v("Wiederholung E-Mailadresse")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group text-left mb-0 mt-4" }, [
      _c(
        "label",
        { staticClass: "control-label", attrs: { for: "textinput" } },
        [_vm._v("Passwort (mind. 6 Buchstaben, Ziffern oder Sonderzeichen)")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group text-left mb-0 mt-4" }, [
      _c(
        "label",
        { staticClass: "control-label", attrs: { for: "textinput" } },
        [_vm._v("Wiederholung Passwort")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }